import {useCustomerId, useCustomerBaskets} from '@salesforce/commerce-sdk-react'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BasketModel} from '_types'

interface UseCurrentBasketProps {
    id?: string
}

/**
 * This hook combine some commerce-react-sdk hooks to provide more derived data for Retail App baskets
 * @param {string} [id] - basket id to get the current used basket among baskets returned, use first basket in the array if not defined
 */
export const useCurrentBasket = ({id = ''}: UseCurrentBasketProps = {}) => {
    const customerId = useCustomerId()
    const {locale} = useMultiSite()

    const {data: basketsData, ...restOfQuery} = useCustomerBaskets(
        {
            parameters: {customerId, c_locale: locale?.id},
        },
        {
            enabled: !!customerId && !isServer,
        },
    )

    const currentBasket = basketsData?.baskets?.find((basket) => basket?.basketId === id) || basketsData?.baskets?.[0]

    return {
        ...restOfQuery,
        data: currentBasket as unknown as BasketModel,
        derivedData: {
            hasBasket: (basketsData?.total ?? 0) > 0,
            totalItems: currentBasket?.productItems?.reduce((acc, item) => acc + (item.quantity ?? 0), 0) || 0,
        },
    }
}
